import emitter from '../bus';

type IntercomUser = {
  firebase_user_id?: string;
  uid?: string;
  email?: string;
  display_name?: string;
  displayName?: string;
  name?: string;
};

const getIntercomUser = (): IntercomUser | null => {
  if (!window.user) return null;
  return window.user as IntercomUser;
};

const updateIntercomUser = (): boolean => {
  const user = getIntercomUser();
  const intercom = (window as any).Intercom;
  const externalId = user?.firebase_user_id || user?.uid || '';
  if (!user || !externalId || typeof intercom !== 'function') return false;

  const name = user.display_name || user.displayName || user.name || '';
  const email = user.email || '';

  intercom('update', {
    user_id: externalId,
    name,
    email
  });

  return true;
};

const retryUpdateIntercomUser = (maxAttempts = 10, intervalMs = 500) => {
  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;
    const isApplied = updateIntercomUser();
    if (isApplied || attempts >= maxAttempts) {
      window.clearInterval(interval);
    }
  }, intervalMs);
};

const bindIntercomUserData = () => {
  updateIntercomUser();
  retryUpdateIntercomUser(20, 500);

  emitter.on('user:updated', () => {
    updateIntercomUser();
    retryUpdateIntercomUser(12, 500);
  });
};

bindIntercomUserData();
